const BACKGROUND_STORAGE_KEY = 'branch-staff-background';

export const getBackgroundPreference = () => {
  try {
    const stored = JSON.parse(window.localStorage.getItem(BACKGROUND_STORAGE_KEY));
    return { gutterArtwork: stored?.gutterArtwork === true };
  } catch {
    return { gutterArtwork: false };
  }
};

export const saveBackgroundPreference = (preference) => {
  try {
    window.localStorage.setItem(
      BACKGROUND_STORAGE_KEY,
      JSON.stringify({ gutterArtwork: preference.gutterArtwork === true })
    );
    return true;
  } catch {
    return false;
  }
};
